import React from 'react';

export const SectionTitleTestId = 'sectiontitle-content';

export type SectionTitleProps = {
  children: React.ReactNode;
  className?: string;
};

const SectionTitle: React.FC<SectionTitleProps> = ({
  children,
  className = '',
}: SectionTitleProps) => {
  return (
    <div
      className={`${className} checkout-panel-section-header text-left text-lg font-semibold p-2`}
      data-testid={SectionTitleTestId}
    >
      {children}
    </div>
  );
};

export default SectionTitle;
